module.exports = __webpack_public_path__ + "img/saramonic.5df69839.jpeg";